import fetch from "isomorphic-fetch";
import { useHistory } from "react-router-dom";
import { API } from "../config";

import { getCookie, userSessionExpired } from "./auth";
const UploadImage = () => {
  const history = useHistory();
  const uploadImage = (data,type) => {
    return fetch(`${API}/upload/type/${type}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: data
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
    }
  return {
    uploadImage,
  };
};

export default UploadImage;